// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__-hQPx","titleBlock":"Advt_titleBlock__Jr+4H","title":"Advt_title__dS3--","qrsWrapper":"Advt_qrsWrapper__HPPzu","qrCode":"Advt_qrCode__ScoXJ"};